import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Heading1 from '../../site/typography/Heading1'
import Heading2 from '../../site/typography/Heading2'
import Heading4 from '../../site/typography/Heading4'
import Paragraph from '../../site/typography/Paragraph'
import './CompoundTitle.scss'

const CompoundTitle = ({ children, className, center, mainTitle, overtitle, right, small, white, purple, purpleBar, tag }) => (
    <div className={cx(className, 'compound-title-container', white ? 'white' : '', center ? 'center' : '', right ? 'right' : '', purpleBar ? 'purpleBar' : '', purple && 'purple')}>
        {
            overtitle ?
                <Paragraph className='overtitle'>{overtitle}</Paragraph>
            :
                ''
        }
        {
            tag ?
                React.createElement(tag, { className: 'title heading2' }, children)
            : small ?
                <Heading4 className='title'>{children}</Heading4>
            : mainTitle ?
                <Heading1 className='title'>{children}</Heading1>
            :
                <Heading2 className='title'>{children}</Heading2>
        }
    </div>
);

CompoundTitle.propTypes = {
    overtitle: PropTypes.string
}

export default CompoundTitle



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/experience/CompoundTitle/CompoundTitle.jsx